/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Checkbox } from '@blend/enterprise-components';
import { FinalFormInputConfig } from 'blb-ui-types/helpers';
import { WrappedInput } from 'blb-components/WrappedInput';

export const isAdminInputConfig: FinalFormInputConfig<Omit<Checkbox.Props, 'checked'>, string> = {
  component: WrappedInput,
  customComponentProps: {},
  displayAdditionalMessagingInContainer: false,
  inputComponent: Checkbox,
  label: '',
  labelSize: 'sm',
  name: 'isAdmin',
  type: 'checkbox',
};
